import { render, staticRenderFns } from "./pgcyDialog.vue?vue&type=template&id=35e0e2a2&"
import script from "./pgcyDialog.vue?vue&type=script&lang=js&"
export * from "./pgcyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports